import { array, assign, Describe, is, lazy, literal, optional, string, type } from 'superstruct';

import { CheckFilter, FilterBase, TextFilter } from '~modules/media-library/model/Filter';
import type { FilterOption } from '~modules/media-library/model/FilterOption';

export const FilterBaseValidator: Describe<FilterBase> = type({
  id: string(),
  label: string(),
});

export const FilterOptionValidator: Describe<FilterOption> = type({
  id: string(),
  label: string(),
  children: optional(lazy(() => array(FilterOptionValidator))),
});

export const CheckFilterValidator: Describe<CheckFilter> = assign(
  FilterBaseValidator,
  type({
    type: literal('checkbox'),
    options: array(FilterOptionValidator),
  }),
);

export const TextFilterValidator: Describe<TextFilter> = assign(
  FilterBaseValidator,
  type({
    type: literal('text'),
  }),
);

export const isCheckFilter = (value: unknown): value is CheckFilter => is(value, CheckFilterValidator);
export const isTextFilter = (value: unknown): value is TextFilter => is(value, TextFilterValidator);
